module.exports = __webpack_public_path__ + "static/assets/6a8dc5055578021d14e852d671271d5d.png";